import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

export const useGetFolderProgress = (id: string | undefined) => {
  const trpc = useTRPC();
  return useQuery(
    trpc.folders.getProgress.queryOptions(
      { id: id ?? "" },
      { staleTime: Number.POSITIVE_INFINITY, enabled: !!id },
    ),
  );
};
